const cursorElement = document.createElement('div');
cursorElement.id = 'cursor';
cursorElement.innerHTML = '<div class="cursor__circle"></div>';
document.querySelector('body').appendChild(cursorElement);

const cursor = document.querySelector('#cursor');
const cursorCircle = cursor.querySelector('.cursor__circle');

const mouse = { x: -100, y: -100 }; // mouse pointer's coordinates
const pos = { x: 0, y: 0 }; // cursor's coordinates
const speed = 0.1; // between 0 and 1

const updateCoordinates = (e) => {
  mouse.x = e.clientX;
  mouse.y = e.clientY;
};

window.addEventListener('mousemove', updateCoordinates);

function getAngle(diffX, diffY) {
  return (Math.atan2(diffY, diffX) * 180) / Math.PI;
}

function getSqueeze(diffX, diffY) {
  const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
  const maxSqueeze = 0.15;
  const accelerator = 1500;
  return Math.min(distance / accelerator, maxSqueeze);
}

const updateCursor = () => {
  const diffX = Math.round(mouse.x - pos.x);
  const diffY = Math.round(mouse.y - pos.y);

  pos.x += diffX * speed;
  pos.y += diffY * speed;

  const angle = getAngle(diffX, diffY);
  const squeeze = getSqueeze(diffX, diffY);

  const scale = 'scale(' + (1 + squeeze) + ', ' + (1 - squeeze) + ')';
  const rotate = 'rotate(' + angle + 'deg)';
  const translate = 'translate3d(' + pos.x + 'px ,' + pos.y + 'px, 0)';

  cursor.style.transform = translate;
  cursorCircle.style.transform = rotate + scale;
};

function loop() {
  updateCursor();
  requestAnimationFrame(loop);
}

requestAnimationFrame(loop);

const startCursor = function (btns) {
  btns.forEach((cursorModifier) => {
    cursorModifier.addEventListener('mouseenter', function () {
      cursor.classList.add('cursor-btn');
    });

    cursorModifier.addEventListener('mouseleave', function () {
      cursor.classList.remove('cursor-btn');
    });
  });
};

if (document.querySelectorAll('.article--ajax-wrapper').length < 1) {
  const cursorModifiers = document.querySelectorAll(
    '.btn-main, .owl-prev, .owl-next'
  );
  startCursor(cursorModifiers);
} else {
  const cursorModifiers = document.querySelectorAll('.btn--more');
  startCursor(cursorModifiers);
}

const animateSocials = function () {
  if (document.querySelectorAll('.__js_socialShare').length > 0) {
    document
      .querySelectorAll('.__js_socialShare:not(.__js_socialShare--loaded)')
      .forEach((el) => {
        el.classList.add('__js_socialShare--loaded');
        el.addEventListener('mouseenter', function () {
          if (this.getAttribute('data-category') === 'facebook') {
            el.closest('.socials-items').classList.remove(
              'socials-items-right'
            );
            el.closest('.socials-items').classList.add('socials-items-left');
          } else {
            el.closest('.socials-items').classList.remove('socials-items-left');
            el.closest('.socials-items').classList.add('socials-items-right');
          }
        });
        el.addEventListener('mouseleave', function () {
          el.closest('.socials-items').classList.remove('socials-items-left');
          el.closest('.socials-items').classList.remove('socials-items-right');
        });
      });
  }
};

animateSocials();
